"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var statementApi = _interopRequireWildcard(require("@/api/merchantStatement"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ReconciliationRemarkDialog',
  data: function data() {
    return {
      visible: false,
      submitLoading: false,
      form: {
        id: '',
        statementNo: '',
        reconciliationRemark: ''
      },
      rules: {}
    };
  },
  methods: {
    open: function open(row) {
      this.form = {
        id: row.id,
        statementNo: row.statementNo,
        reconciliationRemark: row.reconciliationRemark || ''
      };
      this.visible = true;
    },
    handleSubmit: function handleSubmit() {
      var _this = this;
      this.$refs.formRef.validate(function (valid) {
        if (!valid) return;
        _this.submitLoading = true;
        statementApi.statementReconciliationRemarkApi({
          id: _this.form.id,
          reconciliationRemark: _this.form.reconciliationRemark
        }).then(function () {
          _this.$message.success('保存成功');
          _this.visible = false;
          _this.$emit('refresh');
        }).finally(function () {
          _this.submitLoading = false;
        });
      });
    }
  }
};